import React from 'react'
import PropTypes from 'prop-types'
import GoogleMapReact from 'google-map-react'
import { StaticQuery, graphql } from 'gatsby'

import { MAP_STYLE } from '../../constants/map'

const GOOGLE_MAPS_SETTINGS = {
  options: {
    styles: MAP_STYLE,
    fullscreenControl: false
  },
  defaultZoom: 9,
  defaultCenter: { lat: -29.4952179, lng: -51.1530131 }
}

const getMapBounds = (maps, places) => {
  const bounds = new maps.LatLngBounds()

  places.forEach(place => {
    bounds.extend(new maps.LatLng(place.lat, place.lng))
  })
  return bounds
}

const onApiLoad = (map, maps, children) => {
  const places = React.Children.map(children, child => ({
    lat: child.props.lat,
    lng: child.props.lng
  }))
  const bounds = getMapBounds(maps, places)
  map.fitBounds(bounds)
}

const Map = props => {
  return (
    <GoogleMapReact
      {...GOOGLE_MAPS_SETTINGS}
      yesIWantToUseGoogleMapApiInternals
      bootstrapURLKeys={{
        key: props.site.siteMetadata.googleMapsApiKey
      }}
      onGoogleApiLoaded={({ map, maps }) => onApiLoad(map, maps, props.children)}
    >
      {props.children}
    </GoogleMapReact>
  )
}

Map.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  site: PropTypes.shape({
    siteMetadata: PropTypes.shape({
      googleMapsApiKey: PropTypes.string
    })
  })
}

const mapQuery = graphql`
  query MapQuery {
    site {
      siteMetadata {
        googleMapsApiKey
      }
    }
  }
`

export default props => (
  <StaticQuery query={mapQuery} render={data => <Map {...data} {...props} />} />
)
